type IconProps = React.ComponentProps<'svg'>

export function ArrowNarrowUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M12.7499 0C13.1641 3.04072e-05 13.4999 0.335805 13.4999 0.75V8.75C13.4999 9.16419 13.1641 9.49997 12.7499 9.5C12.3357 9.5 11.9999 9.16421 11.9999 8.75V2.56055L1.28022 13.2803C0.987333 13.5732 0.512565 13.5731 0.21967 13.2803C-0.0732233 12.9874 -0.0732233 12.5126 0.21967 12.2197L10.9394 1.5H4.74994C4.33573 1.5 3.99994 1.16421 3.99994 0.75C3.99994 0.335786 4.33573 0 4.74994 0H12.7499Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
